module.exports = __webpack_public_path__ + "static/service-2-138642a7b508fa9dfef70f24d2b986cb.jpg";